import Smart from 'hocs/smart';
import { permissionsForCurrentUserAndOrg } from 'selectors/permissions';
import AssetQuery from './asset-query';

export default Smart(
  AssetQuery,
  state => ({
    organisationId: state.session.organisationId,
    previousColors: state.settings.map.previousColors,
    serialType: state.settings.ui.serialType,
    permissions: permissionsForCurrentUserAndOrg(state),
  }),
  ac => ({
    navigate: ac.router.navigate,
    setPreviousColors: ac.settings.setPreviousColors,
    displaySnackbar: ac.app.displaySnackbar,
  })
);
